'use strict'

module.exports = '/spdy/3.1.0'
